import { ExternalBuyerMappingsState } from './external-buyer-mappings-state.model';

export const INITIAL_EXTERNAL_BUYER_MAPPINGS_STATE: ExternalBuyerMappingsState =
  {
    uploadStatus: 'idle',
    uploadSuccessCount: null,
    uploadError: null,
    downloadStatus: 'idle',
    downloadError: null,
  };
